import { Attributes, Misc, NeoModel, Rules, Validation, ValueObject } from "@singularsystems/neo-core";
import { TextConstants } from "../../../Common/TextConstants";
@NeoModel
export default class ScheduleWACCommand extends ValueObject {
    
    public staticServiceProviderFileGroupingID: number | null = 0;

    public staticServiceProviderID: number | null = 0;

    public serviceProviderGroupingName: string | null = null;

    public serviceProviderName: string | null = null;

    public rawImportLogID: number = 0;

    public staticInstrumentName: string | null = null;
    
    public staticInstumentID: number = 0;

    public clientAccountName: string | null = null;

    public clientAccountId: number = 0;

    public runWACRollover: boolean = true;

    public processToBeRun: string = "";

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDateRange: Date | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDateRange: Date | null = null;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        rules.warnWhen((c) => {
            if(c.startDateRange !== null && c.endDateRange !==null)
            {
                var dateDiff = Math.abs(c.startDateRange!.getTime() - c.endDateRange!.getTime());   //gets the millisecond difference between the two days
                return Math.ceil(dateDiff / (1000 * 3600 * 24)) > 93; //converts it to days and checks if its larger that 3 months
            }
            return false;
        }, 
        "Dates are further than 3 months apart.").onProperties(c => [c.startDateRange]);

        rules.failWhen((s) => s.processToBeRun === TextConstants.Buttons.BookCostCalculation 
                                && s.startDateRange === null,
                                "Please provide a start date.").onProperties(s => s.startDateRange);

        rules.failWhen((s) => s.processToBeRun === TextConstants.Buttons.BookCostCalculation
                                && s.endDateRange === null,
                                "Please provide an end date.").onProperties(s => s.endDateRange);

        rules.failWhen((s) => s.processToBeRun === TextConstants.Buttons.BookCostCalculation
                                && s.staticServiceProviderFileGroupingID === 0,
                                "Please select a broker.").onProperties(s => s.staticServiceProviderFileGroupingID);

        rules.failWhen((s) => s.processToBeRun === TextConstants.Buttons.RunInterception
                                && s.staticServiceProviderID === 0,
                                "Please select a service provider.").onProperties(s => s.staticServiceProviderID);
    }
}